import { PText } from '@porsche-design-system/components-react';
import { type ReactNode } from 'react';
import styled from 'styled-components';

const StyledTextWrapper = styled.div`
    font-size: 16px;
    height: 54px;
    padding: 8px 16px;
    border: 2px solid rgb(148, 149, 152);
    border-radius: 4px;
    outline: 0px;
    display: flex;
    align-items: center;

    &:focus:not(:disabled) {
        border-color: rgb(1, 2, 5);
    }

    & p-text.hydrated[disabled='true'],
    p-text.hydrated[aria-disabled='true'] {
        color: var(--calculator-field-disabled-label-color, rgba(0, 0, 0, 0.25));
    }
`;

const DisplayField = ({ disabled, ...props }: { children: ReactNode; disabled?: boolean }) => (
    <StyledTextWrapper className="porsche-v3-calculator-display-field-wrapper">
        <PText aria-disabled={disabled} color="inherit" {...props} />
    </StyledTextWrapper>
);

export default DisplayField;
